import { create } from 'zustand';

export interface ModulePermissions {
  read?: boolean;
  write?: boolean;
  delete?: boolean;
  [key: string]: boolean | undefined;
}

export type PermissionsMap = Record<string, ModulePermissions>;

interface PermissionsState {
  permissions: PermissionsMap;
  setPermissions: (permissions: PermissionsMap) => void;
  clearPermissions: () => void;
  hasPermission: (module: string, action: string) => boolean;
}

const usePermissionsStore = create<PermissionsState>()((set, get) => ({
  permissions: {},

  setPermissions: (permissions) => set({ permissions }),

  clearPermissions: () => set({ permissions: {} }),

  hasPermission: (module, action) => {
    const perms = get().permissions;
    // Users with admin.manage_settings are superadmins — they pass all checks.
    const isSuperadmin = Boolean(perms['admin']?.['manage_settings']);
    return isSuperadmin || Boolean(perms[module]?.[action]);
  },
}));

export default usePermissionsStore;
